import * as types from './actionTypes';

export const changeQty = (value, inputType, error) => (
    {
        type: types.QTY_CHANGED,
        value,
        inputType,
        error,
    }
);

export const selectFabric = fabricId => ({
    type: types.FABRIC_SELECTED,
    fabricId,
});

export const fashionSizeSelected = size => ({
    type: types.FASHION_SIZE_SELECTED,
    size,
});

export const sewpatOptionsSelected = options => ({
    type: types.SEWPAT_OPTIONS_SELECTED,
    options,
});

export const selectProduct = productId => ({
    type: types.PRODUCT_SELECTED,
    productId,
});



// WEBPACK FOOTER //
// ./src/actions/cart.js